import { render, staticRenderFns } from "./APP_bannerInfo.vue?vue&type=template&id=6bb666f1&scoped=true&"
import script from "./APP_bannerInfo.vue?vue&type=script&lang=js&"
export * from "./APP_bannerInfo.vue?vue&type=script&lang=js&"
import style0 from "./APP_bannerInfo.vue?vue&type=style&index=0&id=6bb666f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb666f1",
  null
  
)

export default component.exports